<template>
  <div class="booking-party">
    <img
      v-if="adults && (hasChildren || hasInfants)"
      src="@/assets/images/family.svg"
      class="section-icon party"
      width="16"
      height="16"
    />
    <img
      v-else-if="isOneAdultOnly"
      src="@/assets/images/adult.svg"
      class="section-icon party"
      width="16"
      height="16"
      alt=""
    />
    <img
      v-else-if="isAdultsOnly"
      src="@/assets/images/adults.svg"
      class="section-icon party"
      width="16"
      height="16"
      alt=""
    />
    <img
      v-else-if="isAdultsGroup"
      src="@/assets/images/group.svg"
      class="section-icon party"
      width="16"
      height="16"
      alt=""
    />
    <img
      v-else-if="isChildrenOnly"
      src="@/assets/images/children.svg"
      class="section-icon party"
      width="16"
      height="16"
      alt=""
    />
    <translate
      v-if="hasChildren && hasInfants"
      :tt="{
        adults,
        childrenAges: childrenAgesDisplay,
        childrenCount,
        infantsCount,
        infantsAges: infantsAgesDisplay,
      }"
    >
      {adults} adults, {childrenCount} children (ages: {childrenAges}),
      {infantsCount} infants (ages: {infantsAges})
    </translate>
    <translate
      v-else-if="hasChildren"
      :tt="{ adults, childrenCount, childrenAges: childrenAgesDisplay }"
    >
      {adults} adults, {childrenCount} children (ages: {childrenAges})
    </translate>
    <translate
      v-else-if="hasInfants"
      :tt="{ adults, infantsCount, infantsAges: infantsAgesDisplay }"
    >
      {adults} adults, {infantsCount} infants (ages: {infantsAges})
    </translate>
    <translate v-else :tt="{ adults }"> {adults} adults </translate
    ><template v-if="hasDogs"
      >,
      <img
        v-if="hasDogs"
        src="@/assets/images/dog-green.svg"
        class="section-icon party"
        width="19"
        height="17"
        alt=""
      />
      <translate :tt="{ dogs }" class="dogs"> {dogs} dogs </translate>
    </template>
    <translate
      v-if="hasConvertedChildren"
      :tt="{ minAdultAge }"
      class="converted-ages"
    >
      (listing defines adults as age {minAdultAge}+)
    </translate>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SearchFiltersUrl } from '../../url/search-filters/SearchFiltersUrl'

@Component({})
class BookingParty extends Vue {
  @Prop({ required: true })
  adults: number

  @Prop({ default: () => [] })
  convertedChildrenAges: number[]

  @Prop({ default: () => [] })
  childrenAges: number[]

  @Prop({ default: () => [] })
  infantsAges: number[]

  @Prop()
  minAdultAge: number

  get childrenCount() {
    return this.convertedChildrenAges.length
  }

  get infantsCount() {
    return this.infantsAges.length
  }

  get isOneAdultOnly() {
    return this.adults === 1 && !this.hasChildren && !this.hasInfants
  }

  get isAdultsOnly() {
    return this.adults < 4 && !this.hasChildren && !this.hasInfants
  }

  get isAdultsGroup() {
    return this.adults >= 4 && !this.hasChildren && !this.hasInfants
  }

  get isChildrenOnly() {
    return (this.adults === 0 && this.hasChildren) || this.hasInfants
  }

  get hasChildren() {
    return this.convertedChildrenAges.length > 0
  }

  get hasInfants() {
    return this.infantsCount > 0
  }

  get hasConvertedChildren() {
    return this.convertedChildrenAges.length !== this.childrenAges.length
  }

  get childrenAgesDisplay() {
    return this.convertedChildrenAges.join(', ')
  }

  get infantsAgesDisplay() {
    return this.infantsAges.join(', ')
  }

  get dogs() {
    return SearchFiltersUrl.urlToFilters(this.$route.query)?.party?.dogs || 0
  }

  get hasDogs() {
    return this.dogs > 0
  }
}

export default toNative(BookingParty)
</script>
<style scoped>
.converted-ages {
  font-size: var(--small);
  display: block;
}

.section-icon {
  height: 1em;
  margin: 0;
  width: auto;
}

.section-icon.party {
  filter: hue-rotate(95deg);
  margin-top: -0.2em;
}
</style>
